import { isEmpty } from 'lodash'

const toFileList = (files) => {
  const dataTransfer = new DataTransfer()

  if (isEmpty(files)) return null

  files.forEach((file) => {
    if (file instanceof File) dataTransfer.items.add(file)
  })

  return isEmpty(dataTransfer.files) ? null : dataTransfer.files
}

export default toFileList
